import { render, staticRenderFns } from "./IncompleteProfile.vue?vue&type=template&id=2b4be682&"
import script from "./IncompleteProfile.vue?vue&type=script&lang=ts&"
export * from "./IncompleteProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports